import {cloneDeep} from 'lodash';
import {
	GET_ALL_ITCONTROLS,
	GET_UNRELATED_ITCONTROLS_COUNT,
	SET_LOADER_FOR_RELATED_TASK,
	ADD_ITCONTROL_RELATED_TASK,
	RELATING_ITCONTROLS_RELATE_TASK,
	UNRELATING_ITCONTROLS_RELATE_TASK,
	REMOVE_ITCONTROL_RELATED_TASK
} from '../../actions/actiontypes';
import {isApiResponseOk} from '../../util/utils';
import initialstate from '../initialstate';

export function itcontrolReducer(state = initialstate.itControls, action) {
	function updateRelatedTask(payload, isSorting = false) {
		let itControlIndex = state.data.findIndex((itControl) => itControl.id === payload.itControlId);
		if (itControlIndex !== -1) {
			let itControls = cloneDeep(state);
			itControls.data[itControlIndex].relatedTasks.push(payload);
			if (isSorting) {
				itControls.data[itControlIndex].relatedTasks.sort((a, b) => {
					const aValue = a.taskDisplayName;
					const bValue = b.taskDisplayName;
					return aValue.localeCompare(bValue, undefined, {numeric: true, sensivity: 'base'});
				});
			}
			itControls.data[itControlIndex].addTaskLoader = false;
			return itControls;
		}
		return state;
	}

	switch (action.type) {
		case GET_ALL_ITCONTROLS: {
			return action.response;
		}
		case GET_UNRELATED_ITCONTROLS_COUNT:
			return state;
		case SET_LOADER_FOR_RELATED_TASK: {
			if (action.itControl) {
				return {
					...state,
					data: state.data.map((itControl) => {
						if (itControl.id === action.itControl.id) {
							return {
								...itControl,
								addTaskLoader: true
							};
						}
						return itControl;
					})
				};
			}
			return state;
		}
		case ADD_ITCONTROL_RELATED_TASK: {
			if (action.taskAttributes) {
				return updateRelatedTask(action.taskAttributes);
			}
			return state;
		}
		case RELATING_ITCONTROLS_RELATE_TASK: {
			if (action.taskAttributes && isApiResponseOk(action)) {
				return updateRelatedTask(action.taskAttributes, true);
			}
			return state;
		}
		case UNRELATING_ITCONTROLS_RELATE_TASK:
		case REMOVE_ITCONTROL_RELATED_TASK: {
			if (action.taskAttributes && isApiResponseOk(action)) {
				let itControls = cloneDeep(state);
				let itControl = itControls?.data.find((itControl) => itControl.id === action.taskAttributes.itControlId);
				if (itControl) {
					let relatedTaskIndex = itControl.relatedTasks.findIndex(
						(task) => task.id === action.taskAttributes.taskId || task.taskId === action.taskAttributes.taskId
					);
					if (relatedTaskIndex !== -1) {
						itControl.relatedTasks.splice(relatedTaskIndex, 1);
					}
				}
				return itControls;
			}
			return state;
		}
		default:
			return state;
	}
}
